// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IDocumentIdDto
 */
export interface IDocumentIdDto {
    /**
     * 
     * @type {number}
     * @memberof IDocumentIdDto
     */
    document_id?: number;
}

/**
 * Check if a given object implements the IDocumentIdDto interface.
 */
export function instanceOfIDocumentIdDto(value: object): value is IDocumentIdDto {
    return true;
}

export function IDocumentIdDtoFromJSON(json: any): IDocumentIdDto {
    return IDocumentIdDtoFromJSONTyped(json, false);
}

export function IDocumentIdDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IDocumentIdDto {
    if (json == null) {
        return json;
    }
    return {
        
        'document_id': json['document_id'] == null ? undefined : json['document_id'],
    };
}

export function IDocumentIdDtoToJSON(json: any): IDocumentIdDto {
    return IDocumentIdDtoToJSONTyped(json, false);
}

export function IDocumentIdDtoToJSONTyped(value?: IDocumentIdDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'document_id': value['document_id'],
    };
}

